export function formatCurrency(value) {
  if (typeof value !== "number") {
    return "$0.00";
  }

  let formatted = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  return formatted.replace(",", ".");
}
